// @flow

import * as React from 'react';
import { bindActionCreators } from 'redux';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';

import PageBody from 'components/PageBody/PageBody';
import NoRecord from 'components/NoRecord/NoRecord';
import { getPortalPath } from 'modules/app/selector';
import {
  getLatestKeywords,
  getIsFirstEntry,
} from 'scenes/UmbrellaHome/duck/selector';

import { onMount } from './duck/duck';
import './duck/epics';
import UmbrellaEvents from './UmbrellaEvents/UmbrellaEvents';
import EventListHeader from './EventListHeader/EventListHeader';

class Home extends React.Component<*, *> {
  componentDidMount() {
    const { portalPath, latestKeywords } = this.props;
    const { portalType, portalId } = portalPath;

    if (!latestKeywords) {
      this.props.onMount(portalType, portalId);
    }
  }

  renderEventListHeader = (total, pagination) => {
    return (
      <EventListHeader total={total} pagination={pagination} />
    );
  }

  renderEmptyListHint = () => {
    const { isFirstEntry, latestKeywords } = this.props;

    return isFirstEntry ? (
      <NoRecord />
    ) : (
      <div className="search-sets__container-empty">
        <i className="icon-search" />
        <div className="search-sets__container-empty-description">
          <L10nMessage id="page.search.empty.label" />
        </div>
        <div className="search-sets__container-empty-text">
          {latestKeywords}
        </div>
      </div>
    );
  }

  render() {
    const { portalType, portalId } = this.props.portalPath;

    return (
      <div className="page">
        <PageBody>
          <UmbrellaEvents
            portalType={portalType}
            portalId={portalId}
            renderEmptyListHint={this.renderEmptyListHint}
            renderTitleComponent={this.renderEventListHeader} />
        </PageBody>
      </div>
    );
  }
}

const mapState = state => ({
  portalPath: getPortalPath(state),
  latestKeywords: getLatestKeywords(state),
  isFirstEntry: getIsFirstEntry(state),
});

const mapDispatch = dispatch => bindActionCreators({ onMount }, dispatch);

export default connect(mapState, mapDispatch)(Home);
